import React from "react";
import LogResult from "../LogResult/LogResult";
import PropTypes from "prop-types";
import { Grid, Button, Input } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import { Formik, Form, ErrorMessage } from "formik";
import moment from "moment";
import * as Yup from "yup";

const dateInputRef = React.createRef();

const LogEntryForm = (props) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    submitBtn: {},
    error: {
      display: "inline-block",
      paddingLeft: ".5rem",
      color: "red",
    },
    resultWrapper: {
      marginTop: ".5em",
    },
    checkbox: {
      paddingLeft: 0,
    },
    input: {
      margin: ".8rem 0",
    },
    checkboxlabel: {
      marginRight: "3em",
    },
  }));

  const initialValues = {
    location: "",
    distance: "",
    date: moment().format("YYYY-MM-DD"),
    isNewShoe: true,
    isNewInsole: false,
  };
  const templateLog = { ...initialValues };

  const classes = useStyles();

  const handleSubmit = (values) => {
    values.distance = parseFloat(values.distance);
    props.change({ ...values });
    dateInputRef.current.focus();
  };

  const handleChange = (name, setFunc, e) => {
    if (e.target.type === "checkbox") {
      templateLog[name] = e.target.checked;
      setFunc(name, e.target.checked);
    } else {
      templateLog[name] = e.target.value;
      setFunc(name, e.target.value);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object({
        date: Yup.date().required("Required").typeError("Invalid date"),
        location: Yup.string()
          .max(25, "25 characters or less")
          .required("Required"),
        distance: Yup.number()
          .typeError("Invalid distance")
          .min(0.001, "Invalid distance")
          .max(100, "Invalid distance")
          .required("Required"),
        isNewShoe: Yup.boolean(),
        isNewInsole: Yup.boolean()
      })}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
        setSubmitting(false);

        // formik doesn't appear to reset checkboxes
        resetForm();
      }}
    >
      {(formik) => (
        <Form
          onSubmit={formik.handleSubmit}
          className={classes.root}
          autoComplete="off"
          noValidate
        >
          <Grid container justify="space-between">
            <Grid item xs={12} sm={7}>
              <div className={classes.input}>
                <Input
                  placeholder="Date"
                  type="date"
                  name="date"
                  inputRef={dateInputRef}
                  {...formik.getFieldProps("date")}
                  onChange={(e) =>
                    handleChange("date", formik.setFieldValue, e)
                  }
                />
                <ErrorMessage
                  component="span"
                  className={classes.error}
                  name="date"
                />
              </div>
              <div className={classes.input}>
                <Input
                  placeholder="Location"
                  name="location"
                  {...formik.getFieldProps("location")}
                  onChange={(e) =>
                    handleChange("location", formik.setFieldValue, e)
                  }
                />
                <ErrorMessage
                  component="span"
                  className={classes.error}
                  name="location"
                />
              </div>
              <div className={classes.input}>
                <Input
                  placeholder="Distance"
                  name="distance"
                  {...formik.getFieldProps("distance")}
                  onChange={(e) =>
                    handleChange("distance", formik.setFieldValue, e)
                  }
                />
                <ErrorMessage
                  component="span"
                  className={classes.error}
                  name="distance"
                />
              </div>
              <div className={classes.input}>
                <FormControlLabel
                  className={classes.checkboxlabel}
                  control={
                    <Checkbox
                      className={classes.checkbox}
                      color="primary"
                      type="checkbox"
                      name="isNewShoe"
                      {...formik.getFieldProps("isNewShoe")}
                      onChange={(e) =>
                        handleChange("isNewShoe", formik.setFieldValue, e)
                      }
                    />
                  }
                  label="New shoes"
                />
                <FormControlLabel
                  className={classes.checkboxlabel}
                  control={
                    <Checkbox
                      className={classes.checkbox}
                      color="primary"
                      type="checkbox"
                      name="isNewInsole"
                      {...formik.getFieldProps("isNewInsole")}
                      onChange={(e) =>
                        handleChange("isNewInsole", formik.setFieldValue, e)
                      }
                    />
                  }
                  label="New insoles"
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={5}>
              <LogResult
                delete={null}
                isActive={false}
                log={templateLog}
                className={classes.resultWrapper}
              />
            </Grid>
          </Grid>

          <Grid container>
            <div>
              <Button
                className={classes.submitBtn}
                type="submit"
                variant="outlined"
                color="primary"
              >
                Submit
              </Button>
            </div>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

LogEntryForm.defaultProps = {};

LogEntryForm.propTypes = {
  change: PropTypes.func.isRequired,
};

export default LogEntryForm;
